module.exports = __webpack_public_path__ + "img/solution.d2626a52.png";